import cn from 'clsx';
import { FC } from 'react';

import type { ButtonModel, TextButtonStateType } from '../../../types';
import Icon from '../../Icon';

import s from './TextButton.module.scss';

export interface TextButtonProps extends Omit<ButtonModel, 'state'> {
  state?: TextButtonStateType;
}

const ICON_SIZE = {
  small: 14,
  default: 16,
  large: 18
};

const TextButton: FC<React.PropsWithChildren<React.PropsWithChildren<TextButtonProps>>> = ({
  size = 'default',
  state = 'primary',
  loading = false,
  disabled = false,
  icon,
  className,
  children,
  ...props
}) => {
  return (
    <button
      type="button"
      className={cn(
        s.button,
        s[size],
        s[state],
        {
          [s.loading as string]: loading
        },
        className
      )}
      disabled={disabled || loading}
      {...props}
    >
      <span className={s.text}>{children}</span>
      {icon && (
        <Icon
          type={icon}
          color={state === 'primary' ? 'violet.600' : 'gray.400'}
          height={ICON_SIZE[size]}
          className={cn({
            [s.animate as string]: icon === 'state-progress'
          })}
        />
      )}
    </button>
  );
};

export default TextButton;
